var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-top"}},[_c('div',{attrs:{"id":"wrapper"}},[_c('div',{staticClass:"d-flex flex-column",attrs:{"id":"content-wrapper"}},[(this.$store.getters['auth/currentUser'])?_c('div',[_c('topNav')],1):_vm._e(),_c('div',{staticClass:"seun"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }